export default __webpack_public_path__ + "486fb20eb4b32eaf2d64526bd5d81e16.png";